var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _priceBreaks, _abortController, _PricePerItemComponent_instances, parsePriceBreaks_fn, attachEventListeners_fn, _handleQuantityUpdate, _handleCartUpdate, getCurrentQuantity_fn, _updatePriceDisplay;
import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
import { StandardEvents } from "@shopify/events";
class PricePerItemComponent extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _PricePerItemComponent_instances);
    /** @type {PriceBreak[]} */
    __privateAdd(this, _priceBreaks, []);
    __privateAdd(this, _abortController, new AbortController());
    /**
     * Handles quantity selector updates
     * @param {Event} event
     */
    __privateAdd(this, _handleQuantityUpdate, (event) => {
      const form = this.closest("product-form-component");
      if (!form || !(event.target instanceof Node) || !form.contains(event.target)) return;
      __privateGet(this, _updatePriceDisplay).call(this);
    });
    /**
     * Handles cart updates by refreshing display after the cart response resolves,
     * so data-cart-quantity is up-to-date when we recalculateo.
     * @param {import('@shopify/events').CartLinesUpdateEvent} event
     */
    __privateAdd(this, _handleCartUpdate, (event) => {
      var _a;
      (_a = event.promise) == null ? void 0 : _a.then(() => __privateGet(this, _updatePriceDisplay).call(this)).catch((error) => {
        if ((error == null ? void 0 : error.name) !== "AbortError") console.warn("[price-per-item] Cart update promise rejected:", error);
      });
    });
    /**
     * Private wrapper for event handlers
     */
    __privateAdd(this, _updatePriceDisplay, () => {
      this.updatePriceDisplay();
    });
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _PricePerItemComponent_instances, parsePriceBreaks_fn).call(this);
    __privateMethod(this, _PricePerItemComponent_instances, attachEventListeners_fn).call(this);
    __privateGet(this, _updatePriceDisplay).call(this);
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    __privateGet(this, _abortController).abort();
  }
  /**
   * Updates the price display based on current quantity
   */
  updatePriceDisplay() {
    var _a;
    if (!__privateGet(this, _priceBreaks).length || !this.refs.pricePerItemText) return;
    const quantity = __privateMethod(this, _PricePerItemComponent_instances, getCurrentQuantity_fn).call(this);
    const priceBreak = (_a = __privateGet(this, _priceBreaks).find((pb) => quantity >= pb.quantity)) != null ? _a : __privateGet(this, _priceBreaks)[__privateGet(this, _priceBreaks).length - 1];
    if (priceBreak) {
      this.refs.pricePerItemText.innerHTML = "".concat(this.dataset.atText, " ").concat(priceBreak.price, "/").concat(this.dataset.eachText);
    }
  }
}
_priceBreaks = new WeakMap();
_abortController = new WeakMap();
_PricePerItemComponent_instances = new WeakSet();
/**
 * Parses price breaks from data attributes
 */
parsePriceBreaks_fn = function() {
  const minQuantity = parseInt(this.dataset.minQuantity || "") || 1;
  const { variantPrice, priceBreaks: priceBreaksData } = this.dataset;
  if (variantPrice) {
    __privateGet(this, _priceBreaks).push({ quantity: minQuantity, price: variantPrice });
  }
  if (priceBreaksData) {
    const breaks = JSON.parse(priceBreaksData);
    for (const { quantity, price } of breaks) {
      if (quantity && price) {
        __privateGet(this, _priceBreaks).push({ quantity: parseInt(quantity), price });
      }
    }
  }
  __privateGet(this, _priceBreaks).sort((a, b) => b.quantity - a.quantity);
};
/**
 * Attaches event listeners for quantity and cart updates
 */
attachEventListeners_fn = function() {
  const { signal } = __privateGet(this, _abortController);
  document.addEventListener(ThemeEvents.quantitySelectorUpdate, __privateGet(this, _handleQuantityUpdate), { signal });
  document.addEventListener(StandardEvents.cartLinesUpdate, __privateGet(this, _handleCartUpdate), { signal });
};
_handleQuantityUpdate = new WeakMap();
_handleCartUpdate = new WeakMap();
/**
 * Gets the total quantity (cart + current input value)
 * @returns {number}
 */
getCurrentQuantity_fn = function() {
  const form = this.closest("product-form-component");
  const quantityInput = (
    /** @type {HTMLInputElement | null} */
    form == null ? void 0 : form.querySelector('input[name="quantity"]')
  );
  if (!quantityInput) return 1;
  const cartQty = parseInt(quantityInput.getAttribute("data-cart-quantity") || "0") || 0;
  const inputQty = parseInt(quantityInput.value) || 1;
  return cartQty + inputQty;
};
_updatePriceDisplay = new WeakMap();
if (!customElements.get("price-per-item")) {
  customElements.define("price-per-item", PricePerItemComponent);
}
